import { FC, useEffect, useRef } from "react";
import {
  IonItem,
  IonLabel,
  IonButton,
  IonText,
  IonList,
  IonIcon,
  IonListHeader,
  IonButtons,
  IonItemDivider
} from "@ionic/react";
import { arrowUndoCircleOutline } from 'ionicons/icons';
import { useDispatch, useSelector } from "react-redux";

import { RootState } from "../../reducers/rootReducer";
import { StatusItem } from "./items/StatusItem";
import { ModeloItem } from "./items/ModeloItem";
import { FrecuenciaItem } from "./items/FrecuenciaItem";
import { VoltajeNominalItem } from "./items/VoltajeNominalItem";
import { CorrienteNominalItem } from "./items/CorrienteNominalItem";
import { UbicacionItem } from "./items/UbicacionItem";
import { FechaInstalacionItem } from "./items/FechaInstalacionItem";
import { MarcaItem } from "./items/MarcaItem";
import { CapacidadItem } from "./items/CapacidadItem ";
import { TablerosItem } from "./items/TablerosItem";
import { ProteccionesItem } from "./items/ProteccionesItem";
import { MedicionesACItem } from "./items/MedicionesACItem";
import { MedicionesCCItem } from "./items/MedicionesCCItem";
import { CanalizacionesItem } from "./items/CanalizacionesItem";
import { AlimentadoresACItem } from "./items/AlimentadoresACItem";
import { AlimentadoresCCItem } from "./items/AlimentadoresCCItem";
import { CircuitosMediaTensionItem } from "./items/CircuitosMediaTensionItem";
import { TransformadoresMedicionItem } from "./items/TransformadoresMedicionItem";
import { TransformadoresItem } from "./items/TransformadoresItem";
import { GeneradoresItem } from "./items/GeneradoresItem";
import { TransferenciasItem } from "./items/TransferenciasItem";
import { startLoadImages } from '../../actions/images';
import { ImagesItem } from './items/ImagesItem';
import { BancoBateriasItem } from "./items/BancoBateriasItem";
import { RectificadorItem } from "./items/RectificadorItem";
import { InversorItem } from "./items/InversorItem";
import { UpsItem } from "./items/UpsItem";
import { AireAcondicionadoItem } from "./items/AireAcondicionadoItem";
import { CeldasMtoItem } from "./items/CeldasMtoItem";
import { TagItem } from "./items/TagItem";
import { DescriptionItem } from "./items/DescriptionItem";
import { NumeroItem } from "./items/NumeroItem";
import { UnidadesItem } from './items/UnidadesItem';


export const EquipoFullScreen: FC = ({ history }: any) => {
  const dispatch = useDispatch();
  const componentMounted = useRef(true);
  useEffect(() => {
    if (componentMounted.current) {
      dispatch(startLoadImages());
    }
    return () => {
      componentMounted.current = false
    }

  }, [dispatch])

  const { activeEquipo: { tag, nombre_equipo, central, id, type } } = useSelector((state: RootState) => state.equipo)

  const goBack = () => {
    history.replace('/equipos')    
  };

  return (
    <>
      <IonList>
        <IonListHeader>
          <IonLabel class="title">Equipo {tag}</IonLabel>
          <IonButtons>
            <IonButton onClick={goBack}><IonIcon className="icon-list" color="primary" icon={arrowUndoCircleOutline}></IonIcon></IonButton>
          </IonButtons>
        </IonListHeader>
        <IonItemDivider>
          <IonLabel>
            Información General
          </IonLabel>
        </IonItemDivider>
        <TagItem />
        <IonItem>
          <IonLabel className="item-label" position="stacked" color="primary">
            Nombre del Equipo
          </IonLabel>
          <IonText><p>{nombre_equipo}</p></IonText>
        </IonItem>
        <DescriptionItem />
        <NumeroItem />
        <IonItem>
          <IonLabel className="item-label" position="stacked" color="primary">Central</IonLabel>
          <IonText><p>{central}</p></IonText>
        </IonItem>
        <ImagesItem idEquipo={id} history={history} />
        <UbicacionItem />
        <StatusItem />
        <FechaInstalacionItem />
        <MarcaItem />
        <ModeloItem />
        <CapacidadItem />
        <UnidadesItem />
        <CorrienteNominalItem />
        <VoltajeNominalItem />
        <FrecuenciaItem />
        <IonItemDivider>
          <IonLabel>
            Información Items
          </IonLabel>
        </IonItemDivider>
        {type === 'TABLEROS' && <TablerosItem />}
        {type === 'INTERRUPTORES' && <ProteccionesItem />}
        {type === 'CELDAS_MT' && <CeldasMtoItem />}
        {type === 'CANALIZACIÓN' && (<>        
        <MedicionesACItem />
        <MedicionesCCItem />
        <CanalizacionesItem />
        <AlimentadoresACItem />
        <AlimentadoresCCItem />
        </>
        )}
        {type === 'CTO_MT' && <CircuitosMediaTensionItem />}
        {type === 'CELDAS_MEDIDA' && <TransformadoresMedicionItem />}
        {type === 'TRANSFORMADOR' && <TransformadoresItem /> }
        {type === 'GENERADOR' &&  <GeneradoresItem />}
        {type === 'RECTIFICADOR' && <RectificadorItem />}
        {type === 'ATS_TRANSFERENCIAS' && <TransferenciasItem />}
        {type === 'INVERSOR' && <InversorItem />}
        {type === 'UPS' && <UpsItem />}
        {type === 'BANCO_BATERIAS' && <BancoBateriasItem />}   
        {type === 'ACONDICIONADO' && <AireAcondicionadoItem />} 
      </IonList>

    </>
  );
};